"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = PreviewLoader;

var _react = _interopRequireDefault(require("react"));

var _betterReactSpinkit = require("better-react-spinkit");

var _jsxFileName = "/opt/build/repo/plugins/wordsby-master/src/components/Preview/PreviewLoader.js";

function PreviewLoader(_ref) {
  var error = _ref.error;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    id: "preview-loader",
    style: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "black",
      flexDirection: "column",
      zIndex: 9999
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }, !error ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_betterReactSpinkit.FoldingCube, {
    size: 200,
    color: "white",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }), _react.default.createElement("p", {
    style: {
      color: "white",
      marginTop: "50px",
      letterSpacing: "1.5px",
      fontFamily: "georgia",
      fontSize: "35px"
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }, "loading")) : _react.default.createElement("div", {
    style: {
      color: "white",
      maxWidth: "90%"
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: this
  }, _react.default.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n                  ::selection {\n                    color: black;\n                    background: yellow;\n                  }\n              "
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }), _react.default.createElement("h1", {
    dangerouslySetInnerHTML: {
      __html: error.title
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }), _react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: error.message
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  }), error.error ? _react.default.createElement("pre", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55
    },
    __self: this
  }, error.error.title ? _react.default.createElement("h1", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56
    },
    __self: this
  }, error.title) : null, error.error.data && error.error.data.status ? _react.default.createElement("h4", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58
    },
    __self: this
  }, "Error: ", error.error.data.status) : null, error.code ? _react.default.createElement("h3", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  }, "Code: \"", error.error.code, "\"") : null, error.error.message ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63
    },
    __self: this
  }, "Message: \"", _react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: error.error.message
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65
    },
    __self: this
  }), "\"")) : null) : null)));
}